;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.Round = Backbone.Model.extend({
		defaults: {
			selected: false
		},

		setDaysToLockout: function() {
			var now    = new Date().getTime(),
				start  = new Date(this.get('start')).getTime(),
				diff   = Math.round(Math.abs((start - now)/(24 * 60 * 60 * 1000)));

			this.set('to_lockout', diff);

			return this;
		},

		setPlayingSquads: function() {
			var squads_id = [];
			var matches = this.get('matches');
			_.each(matches, function(match) {
				if (!_.contains(squads_id, match.away_squad_id)) {
					squads_id.push(match.away_squad_id);
				}
				if (!_.contains(squads_id, match.home_squad_id)) {
					squads_id.push(match.home_squad_id);
				}
			});

			return squads_id;
		},

		setNextGame: function() {
			var matches = this.get('matches'),
				next_match = _.find(matches, function(match) {
								return match.status != 'complete';
							}) || _.last(matches);

			this.set('next_match', next_match);

			return this;
		},

		getNextGame: function() {
			var matches = this.get('matches'),
				next_match = _.find(matches, function(match) {
					return match.status != 'complete';
				}) || _.last(matches);

			return next_match;
		},

		setIsEnd: function() {
			this.set('is_end', this.isEnd);

			return this;
		},

		getFirstMatchKickOff: function(){

			return _.first(this.get('matches')).date;

		},

		getActiveMatch: function(){

			var matches = this.get('matches');

			return _.find(matches, function(match) {
				return Boolean(match.status != 'complete' && match.status != 'scheduled');
			})

		},

		isActiveMatch: function() {
			return Boolean(this.getActiveMatch());
		},

		isEnd: function() {
			var last_match = _.findWhere(this.get('matches'), {is_last: 1});

			return last_match == 'complete';
		},

		isSquadPlayingNow: function(squad_id) {

			var active_match = this.getActiveMatch();

			if(Boolean(active_match)) {
				return active_match.home_squad_id === squad_id || active_match.away_squad_id === squad_id
			}

			return false;

		},

		getNextMatch: function(){
			return _.findWhere(this.get('matches'), {status: 'scheduled'});
		},

		isActive: function() {
			return Boolean(this.get('status') == 'active');
		},

		isComplete() {
			return this.get('status') === 'complete';

		},

		setSquadNames: function(squads) {
			this.set({
				squad_names: _.indexBy(squads, 'id')
			});

			return this;
		},
		setVenuesNames: function(venues) {
			this.set({
				venue_names: _.indexBy(venues, 'id')
			});

			return this;
		},

		isAllMatchesComplete() {
			const not_complete_matches = _.filter(this.get('matches'), match => match.status !== 'complete');

			return !!_.size(not_complete_matches);
		},
		setWinners() {
			_.each(this.get('matches'), match => this.extendMatches(match));
			return  this;
		},

		extendMatches(match) {
			let is_started = match.status !== 'scheduled',
				winner_id = this.getMatchWinnerId(match);
			_.extend(match, {
				is_started:     is_started,
				is_home_winner: winner_id === match.home_squad_id,
				is_away_winner: winner_id === match.away_squad_id,
				is_draw:        !winner_id
			});
		},

		getMatchWinnerId(match) {
			let is_home_winner = match.home_score > match.away_score,
				is_away_winner = match.home_score < match.away_score,
				winner_id      = false;

			if (is_home_winner) {
				winner_id = match.home_squad_id;
			}
			else if (is_away_winner) {
				winner_id = match.away_squad_id
			}

			return winner_id;
		},

	});

}(window, APP, Backbone, Marionette, $, _));
